export default [
  "street_address",
  "city",
  "community_id",
  "country",
  "name",
  "postal_code",
  "region",
  "active",
  "sign_up_inactive",
  "primary_phone_number",
  "website_url",
  "description",
  "hours",
  "complex_name",
  "floors",
  "is_hilo",
  "tenant_id",
];
